<div
  class="tw-reset tw-mx-4 tw-min-h-dvh tw-flex tw-items-start tw-justify-center tw-py-10 md:tw-mx-0"
>
  <div
    class="tw-w-full tw-max-w-md tw-rounded-2xl tw-bg-white tw-p-6 tw-pb-4 tw-shadow-xl"
    role="dialog"
  >
    <div class="tw-flex tw-items-center tw-justify-center tw-pt-6 tw-h-[88px]">
      <da-avatar
        [size]="avatarSize"
        [imageUrl]="ratingInfo().rater.picture"
        [altText]="''"
        aria-hidden="true"
      ></da-avatar>
      <dgx-tag-rating-donut
        size="lg"
        [level]="ratingInfo().level"
        [background]="true"
        class="-tw-ml-2 tw-scale-[0.89]"
      ></dgx-tag-rating-donut>
    </div>

    <h4 class="tw-mt-4 tw-text-center tw-font-semibold tw-text-neutral-800">
      {{ ratingInfo().rater.name }}
    </h4>
    <div class="tw-pb-6">
      <p class="tw-text-center tw-text-sm tw-text-neutral-600">
        {{ ratingInfo().dateCompleted | prettyTimeElapsed: 'minutes' }}
      </p>
      @if (ratingInfo().comment) {
        <p
          class="tw-text-center tw-text-sm tw-text-neutral-600"
          [innerHtml]="ratingInfo().comment"
        ></p>
      }
    </div>
    <div class="tw-flex tw-w-full tw-justify-end tw-gap-4 tw-pt-6">
      @if (allowRatingRequest()) {
        <button
          type="button"
          class="tw-btn-medium tw-btn-secondary-filled"
          [attr.aria-label]="translate('Cancel', 'Core_Cancel')"
          (click)="cancel()"
          data-dgat="completedAssociateRatingModal-1f5"
        >
          {{ translate('Cancel', 'Core_Cancel') }}
        </button>
        <button
          type="button"
          class="tw-btn-primary tw-btn-medium"
          data-dgat="completedAssociateRatingModal-ccf"
          [attr.aria-label]="
            translate('Request New Rating', 'dgTagRating_RequestNewRating')
          "
          (click)="onRequestNewRating($event)"
        >
          {{ translate('Request New Rating', 'dgTagRating_RequestNewRating') }}
        </button>
      } @else {
        <button
          type="button"
          class="tw-btn-primary tw-btn-medium"
          [attr.aria-label]="translate('View Skill', 'dgTagRating_ViewSkill')"
          (click)="onViewTagDetails($event)"
          data-dgat="completedAssociateRatingModal-1f5"
        >
          {{ translate('View Skill', 'dgTagRating_ViewSkill') }}
        </button>
        <button
          type="button"
          class="tw-btn-primary tw-btn-medium"
          data-dgat="completedAssociateRatingModal-ccf"
          [attr.aria-label]="
            translate(
              'View Level Description',
              'dgTagRating_ViewLevelDescription'
            )
          "
          (click)="onViewLevelDescriptions($event)"
        >
          {{
            translate(
              'View Level Description',
              'dgTagRating_ViewLevelDescription'
            )
          }}
        </button>
      }
    </div>
  </div>
</div>
